import React, { useState, useEffect } from "react";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import "./home.scss";
import axios from "axios";
import SlideInModal from "../../components/slideInModal/SlideInModal";
import { formatDate } from "../../utils/formatDate";
import Loading from "../../components/loading/Loading";

const Orders = () => {
  const [orders, setOrders] = useState([]);
  const [selectedOderId, setSelectedOderId] = useState("");
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [orderData, setOrderData] = useState({});
    const [loading, setLoading] = useState(false);

  const columns = [
    { field: "date", headerName: "Date", width: 100 },
    { field: "orderId", headerName: "Order ID.", width: 200 },
    { field: "customer", headerName: "Customer", width: 220 },
    {
      field: "orderStatus",
      headerName: "Order Status",
      width: 150,
      renderCell: (params) => (
        <span
          style={{
            color: params.value?.toLowerCase() === "shipped" ? "green" : "red",
            fontWeight: 600,
          }}
        >
          {params.value}
        </span>
      ),
    },
    {
      field: "paymentStatus",
      headerName: "Payment Status",
      width: 150,
      renderCell: (params) => (
        <span
          style={{
            color:
              params.value?.toLowerCase() === "complete" ? "green" : "orange",
            fontWeight: 600,
          }}
        >
          {params.value}
        </span>
      ),
    },
    { field: "city", headerName: "City", width: 150 },
    { field: "address", headerName: "Address", width: 200 },
    { field: "paymentMethod", headerName: "Payment Method", width: 150 },
    { field: "deliveryCost", headerName: "Delivery Cost", width: 120 },
    { field: "totalAmount", headerName: "Total Amount", width: 120 },
  ];

  useEffect(() => {
    const getAllOrders = async () => {
      try {
        setLoading(true)
        const response = await axios.get("/get-all-orders");

        const formatDate = (dateString) => {
          if (!dateString) return "";
          const date = new Date(dateString);
          // Customize the format (e.g., "M/D/YYYY" or "DD/MM/YYYY")
          return date.toLocaleDateString("en-US", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
          });
          // Alternatively, for a simple date and time:
          // return date.toLocaleString();
        };

        const mappedOrders = response.data.map((order) => ({
          id: order._id, // for DataGrid's internal use
          orderId: order.orderId || "",
          customer: order.fullName || "",
          brand: order.brand || "",
          city: order.city || "",
          address: order.address || "",
          homeName: order.homeName || "",
          landmark: order.landmark || "",
          orderStatus: order.orderStatus || "",
          paymentMethod: order.paymentMethod || "",
          paymentStatus: order.paymentStatus || "",
          totalAmount: order.totalAmount || 0,
          deliveryCost: order.deliveryCost || 0,
          productsList: order.products || [],
          date: formatDate(order.createdAt) || "",
        }));

        setOrders(mappedOrders);
      } catch (error) {
        console.error("Error fetching orders:", error);
      }finally{
        setLoading(false)
      }
    };

    getAllOrders();
  }, []);

   useEffect(() => {
      if (!selectedOderId) {
        return;
      }
      const getOderDetails = async () => {
        try {
          const response = await axios.get(`/get-order-data/${selectedOderId}`);
          setOrderData(response.data);
        } catch (error) {
          return;
        }
      };
      getOderDetails();
    }, [selectedOderId]);


  return (
    <div>
      <div>
        <SlideInModal
          isOpen={isModalOpen}
          onClose={() => {
            setIsModalOpen(false);
          }}
        >
          <div className="oder_details">
            <div className="p_sec">
              <div className="p_in">
                <div>
                  <strong>Order ID :</strong>{" "}
                  <span style={{ color: "orange" }}>
                    {orderData.orderId}
                  </span>
                </div>
                <h5>{orderData?.fullName}</h5>

                <div className="ad_wrp">
                  <strong>Address</strong>
                  <p>
                    {orderData.address}, {orderData.homeName},{" "}
                    {orderData.landmark}, {orderData.city}
                  </p>
                </div>
              </div>
              <div className="p_in">
                <div className="p_data">
                  <p>Payment Status :</p>
                  <p>
                    <em>{orderData.paymentStatus}</em>
                  </p>
                </div>
                <div className="p_data">
                  <p>Payment Method :</p>
                  <p>
                    <em>{orderData.paymentMethod}</em>
                  </p>
                </div>
                <div className="p_data">
                  <p>Order Status :</p>
                  <p>
                    <em>{orderData.orderStatus}</em>
                  </p>
                </div>
                <div className="p_data">
                  <p>
                    Order Date :
                  </p>
                  <p>
                   <em>{formatDate(orderData.createdAt)}</em>
                  </p>
                </div>
              </div>
            </div>
            <div className="products-list">
              {Array.isArray(orderData.products) &&
              orderData.products.length > 0 ? (
                <>
                  <ul>
                    {orderData.products.map((item, i) => (
                      <li key={i} className="product-item">
                        <span className="num">{i + 1}</span>
                        <span className="p-name">{item.title}</span>
                        <div className="od_data">
                          <span className="p-qty">{item.quantity}kg</span>
                          <span className="p-price">{item.price} AED</span>
                          <span className="p-weight">
                            {item.price * item.quantity} AED
                          </span>
                        </div>
                      </li>
                    ))}
                  </ul>
                  <br />
                  <div className="order-total">
                    <strong>Total Amount:</strong>{" "}
                    <strong>{orderData.totalAmount} AED</strong>
                  </div>
                </>
              ) : (
                <p>No Products Found</p>
              )}
            </div>
          </div>
        </SlideInModal>
      </div>
      <div className="main_wrp">
        <div className="main_page_wrp">
          <div className="head_wrp">
            <h5>
              All <em>Orders</em>
            </h5>
          </div>
          <div className="main_body_wrp">
            {loading ? (
              <>
                <Loading />
              </>
            ) : (
              <DataGrid
                rows={orders}
                columns={columns}
                pageSize={5}
                disableRowSelectionOnClick
                getRowId={(row) => row.id}
                slots={{ toolbar: GridToolbar }}
                onCellClick={(params) => {
                  setSelectedOderId(params.row.id);
                  setIsModalOpen(true);
                }}
                slotProps={{
                  toolbar: {
                    showQuickFilter: true,
                    quickFilterProps: { debounceMs: 500 },
                  },
                }}
                sx={{
                  "& .MuiDataGrid-row": {
                    cursor: "pointer",
                  },
                }}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Orders;
